"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRegulations;
var _moment = _interopRequireDefault(require("moment"));
var _RestHelper = _interopRequireDefault(require("../utils/RestHelper"));
function getRegulations(contractId) {
  var now = (0, _moment.default)().format('YYYY-MM-DD');
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(), "/cscn-customer-srv/api/feedin/v0/regulations?contractAccountId=").concat(contractId, "&from=1900-01-01&to=").concat(now));
}